// extracted by mini-css-extract-plugin
export var layoutContainer = "NavigationWrapper_layoutContainer__0MunE";